import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AppSettingsProvider } from './contexts/AppSettingsContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import AppFeatures from './pages/AppFeatures';
import EventCalendar from './pages/EventCalendar';
import ToastLabor from './pages/ToastLabor';
import JobApplications from './pages/JobApplications';
import Resy from './pages/Resy';
import ToastSimulator from './pages/ToastSimulator';
import Analytics from './pages/Analytics';
import Kitchen from './pages/Kitchen';
import Settings from './pages/Settings';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <AppSettingsProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <Layout>
                  <AppFeatures />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/events"
            element={
              <ProtectedRoute>
                <Layout>
                  <EventCalendar />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/labor"
            element={
              <ProtectedRoute>
                <Layout>
                  <ToastLabor />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/job-applications"
            element={
              <ProtectedRoute>
                <Layout>
                  <JobApplications />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/resy"
            element={
              <ProtectedRoute>
                <Layout>
                  <Resy />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/simulator"
            element={
              <ProtectedRoute>
                <Layout>
                  <ToastSimulator />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <Layout>
                  <Analytics />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/kitchen"
            element={
              <ProtectedRoute>
                <Layout>
                  <Kitchen />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Layout>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route path="/" element={<Navigate to="/app" replace />} />
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
      </Router>
      </AppSettingsProvider>
    </AuthProvider>
  );
}

export default App;
